export default "__VITE_ASSET__9vnGilXm__"